import { render, staticRenderFns } from "./CreditRequestTable.vue?vue&type=template&id=5a35766c&scoped=true&"
import script from "./CreditRequestTable.vue?vue&type=script&lang=js&"
export * from "./CreditRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./CreditRequestTable.vue?vue&type=style&index=0&id=5a35766c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35766c",
  null
  
)

export default component.exports